import { createSlice } from '@reduxjs/toolkit';

import initialState from './state';
import { setIsOnline, setLanguageCode, setBackgroundWorker, setIsSupervisorMode, setLockedProject } from './actions';
import { logoutUser } from '../user';

const appSlice = createSlice({
  name: 'app',
  initialState: initialState,
  reducers: {
    setIsOnline,
    setLanguageCode,
    setBackgroundWorker,
    setIsSupervisorMode,
    setLockedProject,
  },
  extraReducers: builder =>
    builder.addCase(logoutUser.fulfilled, state => {
      state.lockedProject = null;
    }),
});

export default appSlice;
